import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Pending Institute Target")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-4" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-2" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Tranche", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Partner", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-3" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", { class: "form-label required" }, "Training Institute", -1)
const _hoisted_16 = { class: "col-md-2 mt-2" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", { class: "" }, "Training Institute Target List", -1)
const _hoisted_19 = { class: "card mb-5 mb-xl-10" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "row mt-1 w-100 m-0" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "div pb-2" }, [
        /*#__PURE__*/_createElementVNode("input", {
          type: "text",
          class: "form-control ps-10 w-200px mt-1 form-control-sm",
          style: {"height":"1em"},
          placeholder: "Search"
        })
      ])
    ])
  ])
], -1)
const _hoisted_21 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_22 = { class: "collapse show" }
const _hoisted_23 = { class: "card-body border-top p-6" }
const _hoisted_24 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check text-light" }, null, -1)
const _hoisted_27 = [
  _hoisted_26
]
const _hoisted_28 = ["onClick"]
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-light" }, null, -1)
const _hoisted_30 = [
  _hoisted_29
]
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_33 = [
  _hoisted_32
]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times text-light" }, null, -1)
const _hoisted_36 = [
  _hoisted_35
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_TargetDrawer = _resolveComponent("TargetDrawer")!
  const _component_ChangeSummaryDrawer = _resolveComponent("ChangeSummaryDrawer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    "collapse-tags": "",
                    "collapse-tags-tooltip": "",
                    placeholder: "Select Tranche",
                    modelValue: _ctx.batch.tranche_id,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.tranche_id) = $event)),
                    multiple: "",
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tranches_info, (tranche) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: tranche.id,
                          label: tranche.label,
                          value: tranche.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tranche.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_el_select, {
                    "collapse-tags": "",
                    "collapse-tags-tooltip": "",
                    class: "form-select-solid",
                    placeholder: "Select Training Partner",
                    modelValue: _ctx.batch.entity_id,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.entity_id) = $event)),
                    style: {"width":"100%"},
                    multiple: "",
                    filterable: "",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.filterEntity(_ctx.batch.entity_id)))
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.entityInfos, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: 
                      '[' + info.entity_short_name + '] - ' + info.entity_name
                    ,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString('[' + info.entity_short_name + '] - ' + info.entity_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Institute",
                    modelValue: _ctx.batch.institute_id,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.batch.institute_id) = $event)),
                    filterable: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.instituteList, (info) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: info.id,
                          label: info.short_name,
                          value: info.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(info.institute_name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("button", {
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.courseInfo())),
                    type: "button",
                    class: "btn btn-success mt-6 p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_17
                  ])
                ])
              ]),
              (_ctx.showCourseNotice == true)
                ? (_openBlock(), _createElementBlock("div", {
                    key: _ctx.componentKey,
                    class: "mt-5"
                  }, [
                    _hoisted_18,
                    _createElementVNode("div", _hoisted_19, [
                      _hoisted_20,
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createVNode(_component_Datatable, {
                                "table-data": _ctx.courseList,
                                "table-header": _ctx.tableHeader,
                                "enable-items-per-page-dropdown": true
                              }, {
                                "cell-sl": _withCtx(({ row }) => [
                                  _createTextVNode(_toDisplayString(row.id), 1)
                                ]),
                                "cell-course": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.course_name), 1)
                                ]),
                                "cell-institute": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.map_institute_course_info[0]
                                ?.institute_info?.institute_name), 1)
                                ]),
                                "cell-target_trainee": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.institute_target_details[0]
                                ?.total_target_trainee), 1)
                                ]),
                                "cell-batch_size": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.trainee_per_batch), 1)
                                ]),
                                "cell-of_batch": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.total_target_batches), 1)
                                ]),
                                "cell-actions": _withCtx(({ row: industry }) => [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (
                                _ctx.Approve(industry.institute_target_details[0].id)
                              ),
                                    class: "btn btn-icon btn-bg-success btn-active-color-primary btn-sm mr-2",
                                    title: "Approve"
                                  }, _hoisted_27, 8, _hoisted_25),
                                  (industry.update_status == 1)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        "data-kt-drawer-toggle": "true",
                                        "data-kt-drawer-target": "#kt_drawer_institute_target_change_summery",
                                        onClick: ($event: any) => (
                                _ctx.view(industry.institute_target_details[0])
                              ),
                                        id: "kt_drawer_institute_target_change_summery_button",
                                        title: "View",
                                        class: "btn btn-icon btn-bg-info btn-active-color-primary btn-sm me-1"
                                      }, _hoisted_30, 8, _hoisted_28))
                                    : _createCommentVNode("", true),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.edit(industry)),
                                    "data-kt-drawer-toggle": "true",
                                    "data-kt-drawer-target": "#kt_modal_institute_target",
                                    id: "kt_modal_institute_target_button",
                                    class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                  }, _hoisted_33, 8, _hoisted_31),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (
                                _ctx.Reject(industry.institute_target_details[0].id)
                              ),
                                    class: "btn btn-icon btn-bg-warning btn-active-color-danger btn-sm me-1",
                                    title: "Reject"
                                  }, _hoisted_36, 8, _hoisted_34)
                                ]),
                                "cell-requested_by": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.request_by), 1)
                                ]),
                                "cell-requested_date_time": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.request_date_time), 1)
                                ]),
                                _: 1
                              }, 8, ["table-data", "table-header"])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])
    ]),
    _createVNode(_component_TargetDrawer),
    _createVNode(_component_ChangeSummaryDrawer)
  ], 64))
}